import { render, staticRenderFns } from "./CreateFarm.vue?vue&type=template&id=2980c124&"
import script from "./CreateFarm.vue?vue&type=script&lang=js&"
export * from "./CreateFarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports